/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useAppData } from '@/hooks/useAppData';

export function useDeviceType() {
  const { appData } = useAppData();
  return appData.deviceType;
}
